import get from 'lodash/get';
import { getMeta } from '../../../../src/helpers';
import { message } from '@grininc/grin-ui';

const UPLOAD_ERROR_MESSAGE = 'Upload failed, please try again or contact support';

export default {
    data() {
        return {
            uploadedFiles: []
        };
    },

    computed: {
        uploadHeaders() {
            return { 'X-CSRF-TOKEN': getMeta('csrf-token') };
        },

        hasUploadedFiles() {
            return this.uploadedFiles.length > 0;
        }
    },

    methods: {
        handleResetUploadedFiles() {
            this.uploadedFiles?.splice(0);
        },

        handleFileDelete(fileName) {
            this.uploadedFiles = this.uploadedFiles?.filter((file) => file.name !== fileName);
        },

        handleUploadChange(uploadInfo, handleSuccess = null, handleError = null, saveFiles = false) {
            //Skip this one. The data is missing the response property.
            if (uploadInfo.event) {
                return;
            }
            const status = get(uploadInfo, 'file.status');
            if (status === 'done') {
                if (saveFiles) {
                    let response = uploadInfo?.file?.xhr?.response;
                    if (response) {
                        response = JSON.parse(response);
                        this.uploadedFiles.push(response);
                    }
                }

                if (handleSuccess) {
                    return handleSuccess(uploadInfo);
                }
            }
            if (status === 'error') {
                if (handleError) {
                    return handleError(uploadInfo);
                }
                return this.handleUploadError(uploadInfo);
            }
        },

        handleUploadError(uploadInfo) {
            const code = get(uploadInfo, 'file.error.status');

            if (code === 422) {
                return message.error(get(uploadInfo, 'file.response.message', UPLOAD_ERROR_MESSAGE));
            }

            return message.error(UPLOAD_ERROR_MESSAGE);
        },

        handleBeforeUpload(file, validationOnly = false) {
            const isLt500MB = file.size / 1000000 < 500;

            if (!validationOnly && !isLt500MB) {
                message.error('File must smaller than 500MB.');
            }

            return isLt500MB;
        }
    }
};
